import React from 'react';
import queryString from 'query-string';
import styled from 'styled-components';

const SocialLink = styled.a`
  text-decoration: none;
`;

const SocialButton = styled.button`
  background: #000;
  border: none;
  cursor: pointer;
  border-radius: 9999px;
  font-size: 1rem;
  transition: 25ms ease-out;
  padding: 0.5rem;

  &.email {
    &:active,
    &:hover {
      background-color: #5e5e5e;
      border-color: #5e5e5e;
    }
  }

  &.facebook {
    &:active,
    &:hover {
      background-color: #2d4373;
      border-color: #2d4373;
    }
  }

  &.instagram {
    &:active,
    &:hover {
      background-color: #dd3856;
      border-color: #dd3856;
    }
  }

  &.linkedin {
    &:active,
    &:hover {
      background-color: #046293;
      border-color: #046293;
    }
  }

  &.twitter {
    &:active,
    &:hover {
      background-color: #2795e9;
      border-color: #2795e9;
    }
  }
  &.pinterest {
    &:active,
    &:hover {
      background-color: #2795e9;
      border-color: #2795e9;
    }
  }
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 1.5em;
  width: 1.5em;

  svg {
    width: 1.25em;
    height: 1.25em;
    fill: #fff;
    stroke: none;
  }
`;

const PROFILES = {
  facebook: 'https://www.facebook.com/askzeta',
  instagram: 'https://www.instagram.com/askzeta/',
  linkedIn: 'https://www.linkedin.com/company/askzeta',
  twitter: 'https://twitter.com/askzeta',
  pinterest: 'https://pinterest.com/askzeta'
};

const createEmailBody = postUrl =>
  `I thought you might be interested in this article in The Money Date Mag: ${postUrl}`;

const createEmailShareLink = ({ subject, body }) =>
  `mailto:?${queryString.stringify({ subject, body })}`;

export function Email({ contentItem, postUrl, subject, body, ...props }) {
  if (!contentItem) return null;
  const href = createEmailShareLink({
    subject: subject || contentItem.title,
    body: body || createEmailBody(postUrl)
  });

  return (
    <SocialLink href={href} target="_email" aria-label="Share on Email" {...props}>
      <SocialButton className="email">
        <IconContainer aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M22 4H2C.9 4 0 4.9 0 6v12c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.25 14.43l-3.5 2c-.08.05-.17.07-.25.07-.17 0-.34-.1-.43-.25-.14-.24-.06-.55.18-.68l3.5-2c.24-.14.55-.06.68.18.14.24.06.55-.18.68zm4.75.07c-.1 0-.2-.03-.27-.08l-8.5-5.5c-.23-.15-.3-.46-.15-.7.15-.22.46-.3.7-.14L12 13.4l8.23-5.32c.23-.15.54-.08.7.15.14.23.07.54-.16.7l-8.5 5.5c-.08.04-.17.07-.27.07zm8.93 1.75c-.1.16-.26.25-.43.25-.08 0-.17-.02-.25-.07l-3.5-2c-.24-.13-.32-.44-.18-.68s.44-.32.68-.18l3.5 2c.24.13.32.44.18.68z" />
          </svg>
        </IconContainer>
      </SocialButton>
    </SocialLink>
  );
}

const createFacebookShareLink = shareUrl =>
  `https://www.facebook.com/sharer/sharer.php?${queryString.stringify({ u: shareUrl })}`;

export function Facebook({ shareUrl, ...props }) {
  const href = shareUrl ? createFacebookShareLink(shareUrl) : PROFILES['facebook'];
  return (
    <SocialLink href={href} target="_facebook" aria-label="Share on Facebook" {...props}>
      <SocialButton className="facebook">
        <IconContainer aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z" />
          </svg>
        </IconContainer>
      </SocialButton>
    </SocialLink>
  );
}

export function Instagram(props) {
  return (
    <SocialLink
      href={PROFILES['instagram']}
      target="_instagram"
      aria-label="Share on Instagram"
      {...props}
    >
      <SocialButton className="instagram">
        <IconContainer aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
          </svg>
        </IconContainer>
      </SocialButton>
    </SocialLink>
  );
}

export function YouTube() {
  return (
    <IconContainer aria-hidden="true">
      <SocialLink href={PROFILES.youtube} target="_blank">
        <svg width="27" height="23" viewBox="0 0 27 23" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.47969 2.76964C11.6117 2.32619 15.3889 2.32619 18.5209 2.76964C21.3665 3.17322 23.5717 5.16938 23.9922 7.32021C24.5033 9.92416 24.5033 13.0755 23.9922 15.6794C23.5705 17.8303 21.3665 19.8264 18.5209 20.23C15.3889 20.6735 11.6105 20.6735 8.47969 20.23C5.63408 19.8264 3.43009 17.8303 3.00838 15.6794C2.49726 13.0755 2.49726 9.92416 3.00838 7.32021C3.43009 5.16938 5.63408 3.17322 8.47969 2.76964ZM18.8592 0.377151C15.5037 -0.0977222 11.4969 -0.0977222 8.14136 0.377151C4.49825 0.893108 1.29618 3.49222 0.637639 6.85621C0.0660994 9.76708 0.0660994 13.2326 0.637639 16.1434C1.29618 19.5074 4.49825 22.1065 8.14136 22.6225C11.4969 23.0974 15.5037 23.0974 18.8592 22.6225C22.5024 22.1065 25.7044 19.5074 26.363 16.1434C26.9345 13.2326 26.9345 9.76708 26.363 6.85621C25.7044 3.49222 22.5024 0.893108 18.8592 0.377151ZM11.7543 5.66117C11.5723 5.53976 11.3608 5.47003 11.1423 5.45942C10.9238 5.4488 10.7065 5.49771 10.5136 5.60091C10.3207 5.70411 10.1595 5.85774 10.047 6.04541C9.93464 6.23308 9.87528 6.44774 9.87531 6.6665V16.3331C9.87528 16.5519 9.93464 16.7666 10.047 16.9542C10.1595 17.1419 10.3207 17.2955 10.5136 17.3987C10.7065 17.5019 10.9238 17.5508 11.1423 17.5402C11.3608 17.5296 11.5723 17.4599 11.7543 17.3385L19.0042 12.5051C19.1697 12.3948 19.3054 12.2453 19.3993 12.0699C19.4931 11.8946 19.5422 11.6987 19.5422 11.4998C19.5422 11.3009 19.4931 11.1051 19.3993 10.9297C19.3054 10.7543 19.1697 10.6048 19.0042 10.4945L11.7543 5.66117ZM16.155 11.4998L12.292 14.076V8.92487L16.155 11.4998Z"
            fill="white"
          />
        </svg>
      </SocialLink>
    </IconContainer>
  );
}

const createLinkedInShareLink = (shareUrl, shareText) =>
  `https://www.linkedin.com/sharing/share-offsite/?${queryString.stringify({
    url: shareUrl,
    title: shareText
  })}`;

export function LinkedIn({ shareUrl, shareText = '', ...props }) {
  const href = shareUrl
    ? createLinkedInShareLink(shareUrl, shareText)
    : PROFILES['linkedIn'];
  return (
    <SocialLink href={href} target="_linkedin" aria-label="Share via LinkedIn" {...props}>
      <SocialButton className="linkedin">
        <IconContainer aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M6.5 21.5h-5v-13h5v13zM4 6.5C2.5 6.5 1.5 5.3 1.5 4s1-2.4 2.5-2.4c1.6 0 2.5 1 2.6 2.5 0 1.4-1 2.5-2.6 2.5zm11.5 6c-1 0-2 1-2 2v7h-5v-13h5V10s1.6-1.5 4-1.5c3 0 5 2.2 5 6.3v6.7h-5v-7c0-1-1-2-2-2z" />
          </svg>
        </IconContainer>
      </SocialButton>
    </SocialLink>
  );
}

const createTwitterShareLink = text =>
  `https://twitter.com/intent/tweet?${queryString.stringify({ text })}`;

export function Twitter({ shareText, ...props }) {
  const href = shareText ? createTwitterShareLink(shareText) : PROFILES['twitter'];
  return (
    <SocialLink href={href} target="_twitter" aria-label="Share on Twitter" {...props}>
      <SocialButton className="twitter">
        <IconContainer aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M23.44 4.83c-.8.37-1.5.38-2.22.02.93-.56.98-.96 1.32-2.02-.88.52-1.86.9-2.9 1.1-.82-.88-2-1.43-3.3-1.43-2.5 0-4.55 2.04-4.55 4.54 0 .36.03.7.1 1.04-3.77-.2-7.12-2-9.36-4.75-.4.67-.6 1.45-.6 2.3 0 1.56.8 2.95 2 3.77-.74-.03-1.44-.23-2.05-.57v.06c0 2.2 1.56 4.03 3.64 4.44-.67.2-1.37.2-2.06.08.58 1.8 2.26 3.12 4.25 3.16C5.78 18.1 3.37 18.74 1 18.46c2 1.3 4.4 2.04 6.97 2.04 8.35 0 12.92-6.92 12.92-12.93 0-.2 0-.4-.02-.6.9-.63 1.96-1.22 2.56-2.14z" />
          </svg>
        </IconContainer>
      </SocialButton>
    </SocialLink>
  );
}

const createPinterestShareLink = (url, imageUrl) =>
  `https://www.pinterest.com/pin/create/button/?${queryString.stringify({
    url
  })}&media=${imageUrl}`;

export function Pinterest({ shareUrl, imageUrl, ...props }) {
  const href = shareUrl
    ? createPinterestShareLink(shareUrl, imageUrl)
    : PROFILES['pinterest'];

  return (
    <SocialLink className="pinterest">
      <SocialButton>
        <IconContainer>
          <a
            aria-hidden="true"
            data-pin-custom="true"
            data-pin-do="buttonPin"
            data-pin-media={imageUrl}
            href={href}
            aria-label="Share on Pinterest"
            {...props}
          >
            <svg
              x="0px"
              y="0px"
              viewBox="0 0 194.755 194.756"
              style={{ enableBackground: 'new 0 0 194.755 194.756' }}
            >
              <g>
                <path
                  d="M150.563,20.704C125.042-7.064,81.976-5.207,53.34,16.214c-24.41,18.26-41.657,58.806-21.144,86.398
              c4.193,5.64,10.337,9.08,17.139,10.477c1.816,0.373,3.275-0.513,3.911-2.221c1.376-3.69,2.844-7.155,3.161-11.106
              c0.121-1.507-1.089-2.354-2.346-2.419c-18.604-20.433-5.967-45.861,12.163-61.586c16.029-13.901,45.463-26.927,64.303-10.91
              c13.001,11.053,13.992,31.707,13.369,47.312c-0.782,19.571-7.62,40.2-27.939,46.425c-6.69,2.05-14.431,1.236-18.872-4.655
              c-5.017-6.655-3.408-14.677-1.507-22.016c2.927-11.3,9.864-27.297,3.294-38.475c-7.954-13.534-23.975-1.228-28.602,7.886
              c-2.818,5.551-7.894,23.332-0.403,27.891c-7.96,20.132-13.33,42.256-16.962,63.492c-1.631,9.536-3.133,20.03-1.327,29.649
              c0.096,0.51,2.155,7.744,4.215,10.572c-0.321,1.824,2.37,2.483,3.442,1.048c7.329-9.81,14.836-19.206,18.879-30.913
              c2.148-6.219,2.946-13.033,4.232-19.469c0.901-4.508,2.746-9.635,3.213-14.439c0.029-0.005,0.056-0.017,0.086-0.021
              c6.327,4.861,14.84,8.976,22.358,10.437c11.822,2.297,25.757-2.104,35.413-8.778c1.476-1.021,2.952-2.248,4.375-3.62
              c4.463-2.973,8.532-6.83,12.01-11.693C179.807,87.505,173.014,45.134,150.563,20.704z M49.843,101.966
              c0.16,0.171,0.328,0.312,0.498,0.436c-0.106,0.236-0.224,0.468-0.335,0.702c-0.24-0.313-0.492-0.617-0.737-0.928
              c0.054-0.29,0.049-0.584-0.017-0.88C49.454,101.518,49.635,101.744,49.843,101.966z M37.422,46.551
              c-1.871,3.248-3.458,6.59-4.765,10.04c1.038-3.714,2.436-7.308,4.171-10.768c0.252,0.106,0.526,0.173,0.812,0.21
              C37.564,46.204,37.496,46.379,37.422,46.551z M151.168,32.688c-0.297-0.385-0.652-0.688-1.042-0.923
              c-0.087-0.125-0.196-0.214-0.295-0.324c-0.125-0.421-0.273-0.817-0.408-1.228c1.133,1.455,2.222,2.95,3.232,4.505
              C152.175,34.035,151.685,33.357,151.168,32.688z"
                />
              </g>
            </svg>
          </a>
        </IconContainer>
      </SocialButton>
    </SocialLink>
  );
}
